// extracted by mini-css-extract-plugin
module.exports = {"ascDesc":"styles_ascDesc__2DlDN","top":"styles_top__3orzL","bottom":"styles_bottom__2ihcx","asc":"styles_asc__30WR2","desc":"styles_desc__17H3u"};